import { render, staticRenderFns } from "./DataPermission.vue?vue&type=template&id=6b9c3e4a&"
import script from "./DataPermission.vue?vue&type=script&lang=js&"
export * from "./DataPermission.vue?vue&type=script&lang=js&"
import style0 from "./DataPermission.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports